import { NextPageContext } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { isProduction } from 'common/utils';
import { generateCookieList } from 'common/utils/trackingTag';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';

// Dynamic import with SSR disabled for better performance
// Timeline content is personalized and doesn't benefit from SSR
const TimelinePage = dynamic(
  () => import('components/v2/modules/timeline-page'),
  {
    ssr: false,
  },
);

const title = 'PostPrime | 資産形成を楽しく学べるプラットフォーム';
const description =
  'PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。';
export default function HomeTimeline(): JSX.Element {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="twitter:url" content={SITE_BASE_URL} />
        <link rel="canonical" href={SITE_BASE_URL} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="og:type" content="website" key="ogtype" />

        {/* Structured data for SEO */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: 'PostPrime',
              url: SITE_BASE_URL,
              description: description,
            }),
          }}
        />
        {isProduction() && (
          <meta
            name="facebook-domain-verification"
            content="bnygafzopgiu9k82kticxuoat5t6lz"
          />
        )}
      </Head>
      <TimelinePage />
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};
